import { ERequestStatus } from 'src/api/enumRequest';
import { IMarketPriceState } from './interface';

export const initialMarketPriceState: IMarketPriceState = {
  getMarketPrice: {
    marketPrice: null,
    status: ERequestStatus.none,
    error: '',
  },
};
